import useComposerReducer from './useComposerReducer';

const useMultiComposerReducer = (params = {}) => {
  const result = useComposerReducer(params);

  return result;
};

export default useMultiComposerReducer;
